import { cn } from "@roman/shared/utils";
import type React from "react";

interface PointIcon {
  className?: string;
}

export const PointIcon: React.FC<PointIcon> = ({ className }) => {
  return <img src="/assets/pointicon.svg" alt="point icon" className={cn("h-6 w-6 inset-0", className)} />;
};
